var map = {
	"./about-header.jpg": 7695,
	"./about-studio.jpg": 4098,
	"./comment1.jpg": 4832,
	"./comment2.jpg": 8447,
	"./comment3.jpg": 6066,
	"./contact-form-background.jpg": 3922,
	"./contact.jpg": 7230,
	"./detailed-service-header.jpg": 6662,
	"./exterior1.jpg": 3625,
	"./exterior2.jpg": 3566,
	"./home-header.jpg": 6791,
	"./home-project-banner.webp": 2782,
	"./interior1.jpg": 7,
	"./interior2.jpg": 5784,
	"./interior3.jpg": 8149,
	"./interior4.jpg": 7326,
	"./jemina.jpg": 3234,
	"./journey1.jpg": 7089,
	"./journey2.jpg": 4950,
	"./journey3.jpg": 9715,
	"./journey4.jpg": 9552,
	"./journey5.jpg": 1293,
	"./layout-plan.png": 5508,
	"./porject-card-02.jpg": 2753,
	"./porject-card-04.jpg": 5535,
	"./porject-card-05.jpg": 9154,
	"./porject-card-06.jpg": 3309,
	"./porject-card-07.jpg": 5216,
	"./porject-card-08.jpg": 523,
	"./project-card-01.jpeg": 7849,
	"./project-card-02.jpeg": 8184,
	"./project-card-03.jpeg": 5599,
	"./project-header.jpg": 7183,
	"./projectbanner-2.jpg": 3974,
	"./quiz-header.jpeg": 8898,
	"./quiz/dining/art-deco.jpg": 7531,
	"./quiz/dining/bohemian.jpg": 3319,
	"./quiz/dining/farmhouse.jpg": 9542,
	"./quiz/dining/industrial.jpg": 1793,
	"./quiz/dining/mid-century.webp": 637,
	"./quiz/dining/modern-minimalist.jpg": 1451,
	"./quiz/dining/scandinavian.avif": 4693,
	"./quiz/dining/vibrant-oriental.jpg": 6491,
	"./quiz/light/art-deco.jpg": 8332,
	"./quiz/light/bohemian.jpg": 2120,
	"./quiz/light/farmhouse.jpg": 39,
	"./quiz/light/industrial.jpg": 4810,
	"./quiz/light/mid-century.png": 8714,
	"./quiz/light/modern-minimalist.jpg": 9462,
	"./quiz/light/scandinavian.jpg": 8880,
	"./quiz/light/vibrant-oriental.jpg": 3968,
	"./quiz/living/art-deco.jpg": 3355,
	"./quiz/living/bohemian.jpg": 5319,
	"./quiz/living/farmhouse.jpg": 3846,
	"./quiz/living/industrial.jpg": 1025,
	"./quiz/living/mid-century.jpg": 4951,
	"./quiz/living/modern-minimalist.jpg": 2075,
	"./quiz/living/scandinavian.jpg": 4167,
	"./quiz/living/vibrant-oriental.jpg": 5115,
	"./quiz/office/art-deco.jpg": 4554,
	"./quiz/office/bohemian.jpg": 1142,
	"./quiz/office/farmhouse.jpg": 9749,
	"./quiz/office/industrial.jpg": 9744,
	"./quiz/office/mid-century.jpg": 6496,
	"./quiz/office/modern-minimalist.jpg": 3792,
	"./quiz/office/scandinavian.jpg": 8906,
	"./quiz/office/vibrant-oriental.jpg": 462,
	"./service-card-01.jpeg": 7339,
	"./service-card-02.webp": 7267,
	"./service-card-03.jpg": 9948,
	"./service-card-04.jpg": 5943,
	"./service-header.jpeg": 8362,
	"./service-journey-banner.jpg": 8953,
	"./trusted-comments-01.jpg": 6942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;